<template>
    <div style="background-color: #EEEEEE;">
        <div style="position:relative;">        
            <div style="position: absolute; top: 10px; right: 10px;">
                <router-link to="/materials" class="not-text-decoration" style="color: black;">Back to materials <v-icon>mdi-close</v-icon></router-link>
            </div>
            <v-container class="py-0">
                <v-row class="py-0" align="center" style="min-height: calc(100vh - 100px - 219px);">
                    <v-col cols="12" md="5" xl="4" offset-xl="1" class="text-center">
                        <v-avatar width="430" height="430" class="d-none d-xl-inline-flex">
                            <v-img :src="'https://artlesscms.actstudio.xyz'+material.materials[$route.params.id].value.Image.path" width="100%"></v-img>
                        </v-avatar>

                        <v-avatar width="370" height="370" class="d-none d-lg-inline-flex d-xl-none">
                            <v-img :src="'https://artlesscms.actstudio.xyz'+material.materials[$route.params.id].value.Image.path" width="100%"></v-img>
                        </v-avatar>

                        <v-avatar width="326" height="326" class="d-none d-md-inline-flex d-lg-none">
                            <v-img :src="'https://artlesscms.actstudio.xyz'+material.materials[$route.params.id].value.Image.path" width="100%"></v-img>
                        </v-avatar>

                        <v-avatar width="247" height="247" class="d-md-none">
                            <v-img :src="'https://artlesscms.actstudio.xyz'+material.materials[$route.params.id].value.Image.path" width="100%"></v-img>
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" md="5" xl="5" class="pl-4">
                        <h2 class="my-4">{{material.name}}</h2>
                        <p class="my-4">{{material.description}}</p>
                        <span class="d-block my-4">Others</span>
                        <div class="my-4">
                            <template v-for="(mat,mat_id) in material.materials">
                                <router-link :to="'/materials/'+$route.params.material+'/'+mat_id" :key="'mat_id-'+mat_id" class="mr-4 d-inline-block">
                                    <v-img :src="'https://artlesscms.actstudio.xyz'+mat.value.Image.path" class="mx-auto text-right align-self-start" v-bind:class="{'request-opacity':mat_id == $route.params.id}" width="48" height="48">
                                        <v-avatar
                                            color="black"
                                            size="16"
                                            class="pointer"
                                            style="vertical-align: top;"
                                            v-if="requestList.includes(mat)"
                                        >
                                            <v-icon color="white" size="11">mdi-check</v-icon>

                                        </v-avatar>
                                    </v-img>
                                </router-link>
                            </template>
                        
                        </div>

                        <template v-for="(mat,mat_id) in material.materials">
                            <template v-if="mat_id == $route.params.id">
                                <div :key="'material-button-add'+mat_id">
                                    <v-btn color="black" block tile dark  @click="requestList.push(mat); refreshSession();" v-if="!requestList.includes(mat)">
                                        request
                                    </v-btn>
                                    <v-btn color="black" block tile dark  @click="remove(mat)" v-else>
                                        remove from request list
                                    </v-btn>
                                </div>
                            </template>
                        </template>


                        <v-btn to="/materials" color="black" block tile dark class="mt-6">
                            Back to Materials
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueSession from 'vue-session'
Vue.use(VueSession, {persist:true});
export default {
    data(){
        return{
            material: {},
            requestList: []
        }
    },
    beforeMount: function(){
        var aux = this;
        fetch(
        "https://www.artlesscms.actstudio.xyz/api/collections/get/Materials?token=a15be93e9cdb43ca2b3778c2077c26",
        {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            filter: {
                _id: this.$route.params.material
            },
            populate: 1 // resolve linked collection items
            })
        }
        )
        .then(res => res.json())
        .then(res => (this.material = res.entries[0]));


        if(this.$session.has('requestList')){
            this.requestList = this.$session.get('requestList');
        }
    },
    methods: {
        remove: function(material){
            let aux = [];
            for (let index = 0; index < this.requestList.length; index++) {
                if(material != this.requestList[index]){
                aux.push(this.requestList[index]);
                }
                
            }

            this.requestList = aux;

            this.refreshSession();
        },
        refreshSession: function(){
            this.$session.set('requestList',this.requestList);
        }
    }
}
</script>